import "./Media.module.css";
import Navigation from "@/reusable_sections/Header";
import Resources from "./sections/Resources";
import Testimonials from "./sections/Testimonials";
import Footer from "@/reusable_sections/Footer";
export default function MediaPage() {
  return <div>
      <Navigation />
      <Resources />
      <Testimonials />
      <Footer />
    </div>;
}